export { default } from "./ClassroomLastSyncFailedBanner";
